module.exports = __webpack_public_path__ + "static/media/qr.ba5b4a0f.jpg";